import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import {ENTITIES_TARIFFS_BASE_URL} from 'app/app.constants';
import {ScaleService} from 'app/blocks/service/api/scale.service';
import {Resource} from 'app/constants/resource';

import {IScale, Scale} from 'app/blocks/model/scale.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class ScaleResource extends AbstractEntityResource<IScale> {
    constructor(scaleService: ScaleService, router: Router) {
        super(
            Resource.SCALES,
            scaleService,
            new EntityNavigator(ENTITIES_TARIFFS_BASE_URL, Resource.SCALES, router),
            new EntityUrlProvider(ENTITIES_TARIFFS_BASE_URL, Resource.SCALES),
            (entity?) => new Scale(entity),
            (entity) => entity.id,
            faStar
        );
    }
}
